import { api } from "./api";

export type TopKey = "LIQUIDE" | "ANLAGEN" | "IMMOBILIE" | "SONSTIGE";
export type SubKey =
  | "AKTIE"
  | "ETF"
  | "KRYPTO"
  | "ANLEIHE"
  | "ROHSTOFFE"
  | "P2P"
  | "BETEILIGUNG"
  | "SONSTIGE";
export type AllocationLevel = "TOP" | "SUB";

export interface AllocationTopItem {
  key: TopKey;
  actualCents: number;
  targetCents?: number;
  driftCents?: number;
  driftPp?: number;
  underwater?: true;
}

export interface AllocationSubItem {
  key: SubKey;
  actualCents: number;
  targetCents?: number;
  driftCents?: number;
  driftPp?: number;
}

export interface CountryAggregation {
  perCountry: { country: string; valueCents: number }[];
  coveredCents: number;
  uncoveredCents: number;
}

export interface AllocationBreakdownEntry {
  name: string;
  detail: string | null;
  valueCents: number;
}

export interface AllocationResponse {
  stichtag: string;
  top: { totalCents: number; items: AllocationTopItem[] };
  sub: { totalCents: number; items: AllocationSubItem[] };
  breakdownBySubKey: Record<string, AllocationBreakdownEntry[]>;
  breakdownByTopKey: Record<string, AllocationBreakdownEntry[]>;
  countries: CountryAggregation;
  otherDebtsCents: number;
  realestateLoansCents: number;
  brokerageCashCents: number;
  sonstigeSnapshotDate: string | null;
}

export interface TargetRow {
  key: string;
  targetBp: number;
}

export interface TargetResponse {
  level: AllocationLevel;
  rows: TargetRow[];
}

export const allocationApi = {
  get: (stichtag?: string) => {
    const qs = stichtag ? `?stichtag=${encodeURIComponent(stichtag)}` : "";
    return api<AllocationResponse>(`/allocation${qs}`);
  },
  getTarget: (level: AllocationLevel) => api<TargetResponse>(`/allocation/target?level=${level}`),
  setTarget: (level: AllocationLevel, rows: TargetRow[]) =>
    api<TargetResponse>(`/allocation/target/${level}`, {
      method: "PUT",
      body: { rows },
    }),
};
